"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _recompose = require("recompose");
var _Chart = require("../Chart");
var _helpers = require("./helpers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable react/no-unused-prop-types */

/* eslint-disable react/no-unused-prop-types */

/**
 * We compose LineChart from presentational component and HOCs and export it as a class
 * so that react-doc-gen continues to work with Flow props and default props.
 */
var ComposedLineChart = (0, _recompose.compose)((0, _recompose.mapProps)(_helpers.getDerivedProps), _Chart.withLegend, /** Provides automatically calculate height/width through props. */
_Chart.withAutoSizer, (0, _recompose.mapProps)(_helpers.calculateLayout),
/**
 * Initialize Line Plot class instance. Plottable API is mutative so this object
 * should not need to be updated.
 */
(0, _recompose.withPropsOnChange)(function () {
  return false;
}, function () {
  return {
    plot: (0, _helpers.createLinePlot)()
  };
}), _Chart.withTooltip,
/**
 * Attach Interactions to Line Plot, which may invoked callbacks provided through
 * props.
 */
(0, _Chart.withPlottableInteractions)([_Chart.createHoverInteraction]))(_Chart.PlottableXYChart);
var LineChart = exports["default"] = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(LineChart, _Component);
  function LineChart() {
    (0, _classCallCheck2["default"])(this, LineChart);
    return _callSuper(this, LineChart, arguments);
  }
  (0, _createClass2["default"])(LineChart, [{
    key: "render",
    value: function render() {
      var theme = this.props.theme;

      // Uses `.line-chart-lume` from LumeTheme.css.
      var colorTheme = theme.lineChartLume ? _Chart.lumeColors : _Chart.defaultColors;
      return /*#__PURE__*/_react["default"].createElement(ComposedLineChart, (0, _extends2["default"])({}, this.props, {
        colors: colorTheme
      }));
    }
  }]);
  return LineChart;
}(_react.Component);
(0, _defineProperty2["default"])(LineChart, "displayName", 'LineChart');
(0, _defineProperty2["default"])(LineChart, "defaultProps", {
  colors: _Chart.defaultColors,
  theme: {},
  data: [],
  isCategorical: true,
  isLoading: false,
  isOverlayShown: false,
  isTimeSeries: false,
  disableAutorangeMode: false,
  tooltipWidth: 150,
  xAxisDomain: undefined,
  yAxisDomain: undefined,
  buildCustomAxes: undefined,
  series: null,
  showLegend: true,
  flyoutComponent: /*#__PURE__*/_react["default"].createElement(_Chart.TooltipFlyout, null),
  showCrosshair: true,
  disableLegendOnClick: false
});
//# sourceMappingURL=LineChart.js.map